// extracted by mini-css-extract-plugin
export default {"container":"LandingPage_container__kBOZw","sections":"LandingPage_sections__KuxY1","section":"LandingPage_section__eOGRE","sectionRoot":"LandingPage_sectionRoot__h6K9S"};